import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select, { selectType } from 'Components/Select';
import { ACTION, STATUS } from 'constants/index';

export default class Row extends React.Component {
  _selectAction = actionKey => {
    const { inspection, performAction } = this.props;

    if (
      actionKey === ACTION.INCOMPLETE_RESPONSE ||
      actionKey === ACTION.APPROVE_RESPONSE ||
      actionKey === ACTION.SUBMIT_RESPONSE
    ) {
      performAction(actionKey, inspection.response.id)();
    } else {
      performAction(actionKey, inspection.id)();
    }
  };

  _getStatusColor = () => {
    const { inspection, user } = this.props;

    if (user.isInspector()) {
      if (inspection && inspection.status) {
        return `list-scene__status-label_${inspection.status.toString().toLowerCase()}`;
      }
    } else {
      if (inspection.status === STATUS.COMPLETE) {
        if (inspection.vresponseRequired) {
          if (inspection && inspection.response && inspection.response.status) {
            return `list-scene__status-label_${inspection.response.status.toString().toLowerCase()}`;
          }
        } else {
          if (inspection && inspection.status) {
            return `list-scene__status-label_${inspection.status.toString().toLowerCase()}`;
          }
        }
      } else {
        if (inspection && inspection.status) {
          return `list-scene__status-label_${inspection.status.toString().toLowerCase()}`;
        }
      }
    }

    return '';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;

    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  render() {
    const { inspection, actionList, getReadableStatus } = this.props;

    return (
      <div
        id={`inspectionListRowID${inspection.id}`}
        onClick={() => this._selectAction(ACTION.DETAILS)}
        className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}
      >
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='inspectionInspectionDateField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('inspectionDate')} _width_pc_12`}
        >
          {moment(inspection.inspectionDate).format('MM/DD/YYYY')}
        </div>

        <div
          id='inspectionInspectorNameField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('inspectorName')} _width_pc_14`}
        >
          {inspection.user ? `${inspection.user.firstName} ${inspection.user.lastName}` : ''}
        </div>

        <div
          id='inspectionInspectionAddressField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('location')} _width_pc_14`}
        >
          {inspection.mnfCity
            ? `${inspection.mnfCity ? inspection.mnfCity + ', ' : ''} ${inspection.mnfState || ''}`
            : 'N/A'}
        </div>

        <div
          id='inspectionYearField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('year')} _width_pc_8`}
        >
          {inspection.year}
        </div>

        <div
          id='inspectionDescriptionField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('description')} list-scene__table-row-element_place_filler`}
        >
          {inspection.description}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_18'>
          <div
            id='inspectionStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle(
              'status'
            )} _width_150`}
          >
            {getReadableStatus(inspection)}
          </div>
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <Select
            placeholder='Actions'
            mainWrapperClassName='_width_120'
            withoutSearch
            multiSelect
            selectionList={actionList}
            handleSelect={this._selectAction}
            type={selectType.listActions}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  inspection: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
};

Row.defaultProps = {
  inspection: {
    user: {
      firstName: '',
      lastName: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/List/Row.jsx